import { getCSSVariableValue } from '@/assets/js/_utils/DomHelpers.js';

export function sparklineOpts(color) {
    return {
        chart: { type: 'area', sparkline: { enabled: true }, background: 'transparent' },
        stroke: { curve: 'smooth', width: 2.5 },
        colors: [color],
        fill: {
            type: 'gradient',
            gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05, stops: [0, 100] },
        },
        tooltip: { enabled: false },
    };
}

export function cssVar(name, fallback) {
    return getCSSVariableValue(name) || fallback;
}
